<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>¡Has llegado al taller de restauración!<br><br>
El tiempo deja huella en las obras de arte, como parte del equipo de restauración, hoy debes intervenir en esta importante pieza sobre la Batalla del 5 de Mayo de 1862.<br><br>
Todo proceso de restauración requiere investigación sobre las obras.<br><br>
 Resuelve los 3 mini-juegos correctamente para descubrir información sobre la pieza y hacer un buen trabajo de restauración.</h2>
  </div>
</template>

<script>
export default {
  name: "InfoBanner",
  data() {
    return {};
  }
};
</script>
